var map = {
	"./brahmin_man.svg": 6319,
	"./coming_soon.svg": 2486,
	"./eskimo_man.svg": 8124,
	"./eskimo_woman.svg": 8902,
	"./golfer_man.svg": 4661,
	"./manu_man.svg": 3445,
	"./manu_woman.svg": 5175,
	"./nilote_man.svg": 3865,
	"./rower_woman.svg": 2637,
	"./sumo_man.svg": 3376,
	"./sumo_woman.svg": 5610,
	"./track_cyclist_man.svg": 9729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 903;